var map = {
	"./007-microphone-1.png": 511,
	"./010-home.png": 512,
	"./013-document-1.png": 513,
	"./014-document.png": 514,
	"./015-color-palette.png": 515,
	"./017-video-camera.png": 516,
	"./image.png": 517,
	"./label.png": 518,
	"./left.svg": 519,
	"./right.svg": 520
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 510;